import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'office-ui-fabric-react';
import {
  HEARINGSTATUS_AWAITING_CONCLUSION,
  HEARINGSTATUS_CONCLUDED,
} from '../../../../../constants/api';
import { HearingStatusTag } from '../../../../../components/HearingStatusTag';
import { getMonthFromDate } from '../../../../../features/helpers/dateHelpers';

import Images from '../../../../../assets/images';
import { useImageDimensionsParser } from '../../../../../hooks/useImageDimensionsParser';

const getImageClassName = (width, height) => {
  const aspectRatio = width / height;

  if (aspectRatio <= 2) {
    return 'hearing-element-picture__fit-width';
  } else {
    return 'hearing-element-picture__fit-height';
  }
};

const HearingElement = ({ onClick, hearingItem }) => {
  const { t: translator } = useTranslation();
  const onClickLocal = () => {
    onClick && onClick(hearingItem);
  };

  const onKeyDown = (event) => {
    if (event.key === 'Enter' && onClick) {
      event.preventDefault();
      onClick(hearingItem);
    }
  };

  const [imageError, setImageError] = useState(false);

  const fallbackImage = Images.fallbackImage;

  const imageUrl = imageError
    ? fallbackImage
    : hearingItem.imageUrl || fallbackImage;

  const { width, height } = useImageDimensionsParser(imageUrl);
  const imageClassName = getImageClassName(width, height);

  const isDeadlineExceeded = getIsDeadlineExceeded(hearingItem.hearingStatus);
  return (
    <div
      className="hearing-element"
      onClick={onClickLocal}
      onKeyDown={onKeyDown}
      tabIndex="0"
      role="link"
    >
      <div className="hearing-element-top">
        <img
          alt={
            hearingItem.imageAltText ||
            translator('hearingProperties.hearingImageAltText')
          }
          src={imageUrl}
          className={imageClassName}
          onError={() => setImageError(true)}
        />
        {isDeadlineExceeded ? (
          <div className="hearing-element-top-date">
            <div style={{ marginTop: '10px', marginBottom: '10px' }}>
              <div
                style={{
                  fontWeight: 'lighter',
                  fontSize: 11,
                  color: '#000000',
                }}
              >
                {translator('components.hearingElement.ended')}
              </div>
              <Icon
                style={{
                  fontSize: '32px',
                  color: '#0078D4',
                  marginTop: '10px',
                }}
                iconName="SkypeCircleCheck"
              />
            </div>
          </div>
        ) : (
          <div className="hearing-element-top-date">
            <div style={{ marginTop: '10px', marginBottom: '10px' }}>
              <div
                style={{
                  fontWeight: 'lighter',
                  fontSize: 11,
                  color: '#000000',
                }}
              >
                {translator('hearingProperties.deadlineDate')}
              </div>
              <div
                style={{ fontWeight: 'bold', fontSize: 30, color: '#000000' }}
              >
                {hearingItem.deadline.slice(0, 2)}
              </div>
              <div style={{ fontSize: 14 }}>
                {getMonthFromDate(hearingItem.deadline)}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="hearing-element-mid">
        <h3>{hearingItem.title}</h3>
        <div className="hearing-element-mid-summary">{hearingItem.summary}</div>
        <div className="hearing-element-mid-dates">
          <div style={{ display: 'inline-block', width: '50%' }}>
            <div style={{ fontWeight: 'lighter', display: 'inline' }}>
              {translator('hearingProperties.startDate')}:
            </div>
            <div style={{ display: 'inline' }}>{hearingItem.startDate}</div>
          </div>
          <div style={{ display: 'inline-block', width: '50%' }}>
            <div style={{ fontWeight: 'lighter', display: 'inline' }}>
              {translator('hearingProperties.deadlineDate')}:
            </div>
            <div style={{ display: 'inline' }}>{hearingItem.deadline}</div>
          </div>
        </div>
      </div>
      <div className="hearing-element-footer">
        <div style={{ display: 'inline-block', marginRight: '12px' }}>
          {translator('hearingProperties.hearingStatus')}:
        </div>
        <div style={{ display: 'inline-block' }}>
          <HearingStatusTag
            status={hearingItem.hearingStatus}
            translator={translator}
          />
        </div>
      </div>
    </div>
  );
};

function getIsDeadlineExceeded(status) {
  if (
    status === HEARINGSTATUS_AWAITING_CONCLUSION ||
    status === HEARINGSTATUS_CONCLUDED
  ) {
    return true;
  }
  return false;
}

export { HearingElement };
